import React from 'react'

import ResourceSelector from '../UI/ResourceSelector'
import Resource from '../../stores/resource'
const UserStore = Resource('users')

/*
Props:
Everything works exactly as in ResourceSelector, except:
- onSelected: function(selectedUserId, selectedUser)
              called when an option is selected
*/
const UserSelector = props => {
  const { unselectedLabel, onSelected } = props

  const _change = value => {
    if (!onSelected) return

    const userId = Number(value)
    if (!userId) return

    UserStore.find(userId).then(response => onSelected(userId, response.data))
  }

  return (
    <ResourceSelector
      resourceAPIEndpoint="users"
      resourcePluralName="users"
      nameAttribute="fullName"
      unselectedLabel={unselectedLabel || 'Select a user'}
      selectedIdCallback={_change}
      {...props}
    />
  )
}

export default UserSelector



// WEBPACK FOOTER //
// ./src/components/Users/UserSelector.jsx